// extracted by mini-css-extract-plugin
module.exports = {"input":"Paragraph_input__3lrN1","text":"Paragraph_text__CQgwF","h1":"Paragraph_h1__DYFSG"};